import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isLanderHost, landerSettings, loadLanderDomain } from "@/lib/landerDomain";
import { applySiteBrand } from "@/pages/landing/config";

const VISITOR = /^\/(lp|go)\//;
const LEGAL = /^\/(privacy|terms|legal-partners)\/?$/;
const PREVIEW_KEYS = ["preview", "demo", "ty_design", "variant", "sample"];
const PLATFORM_HOST = (() => {
  try { return new URL(process.env.REACT_APP_BACKEND_URL).hostname; } catch { return ""; }
})();

const isPreview = (search) => {
  if (window.self !== window.top) return true;
  const q = new URLSearchParams(search);
  return PREVIEW_KEYS.some((k) => q.has(k));
};

// Where this request belongs: stay, or a full address to send the browser to.
function decide(s, { pathname, search, hash }) {
  const visitor = VISITOR.test(pathname);
  if (!s) return { wait: visitor || window.location.hostname !== PLATFORM_HOST };
  if (isLanderHost(s)) {
    if (pathname === "/") return { go: `${s.home_path || "/lp/standard"}${search}` };
    if (visitor || LEGAL.test(pathname)) return { brand: s.brand_name };
    return { go: `${s.platform_origin}${pathname}${search}${hash}` };
  }
  if (s.enabled && s.redirect_old && visitor && !isPreview(search)) {
    return { go: `https://${s.domain}${pathname}${search}${hash}` };
  }
  // Previews stay here (drafts need the login) but wear the landing-domain brand visitors will see.
  if (s.enabled && visitor && isPreview(search)) return { brand: s.brand_name };
  return {};
}

// On the landing domain only visitor pages show (with its brand); old platform lander links move there.
export function LanderHostGuard({ children }) {
  const loc = useLocation();
  const [s, setS] = useState(landerSettings());
  useEffect(() => { loadLanderDomain().then(setS); }, []);
  const d = decide(s, loc);
  if (d.brand) applySiteBrand(d.brand);
  useEffect(() => {
    if (d.go) window.location.replace(d.go);
  }, [d.go]);
  if (d.wait || d.go) return null;
  return children;
}
